module.exports = __webpack_public_path__ + "static/flower-top-left-10f193c297dac36873e3357990c52e27.png";